<template>
  <div class="AddClassify">
    <AppHeader v-if="isAdd" :content="isAddContent"></AppHeader>
    <AppHeader v-else :content="isEditContent"></AppHeader>
    <AppBox class="appBox">
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="父目录" prop="parentId">
          <el-select
            v-model="formData.parentId"
            filterable
            placeholder="请选择"
            style="width: 40%"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目录名称" prop="name">
          <el-input
            maxlength="8"
            show-word-limit
            style="width: 40%"
            v-model="formData.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button
          style="margin-right: 200px; width: 150px"
          type="primary"
          @click="handleConfirm"
          >保存查看
        </el-button>
        <el-button
          v-if="isAdd"
          style="width: 150px"
          type="primary"
          @click="handleAdd"
          >继续新增
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import { classifyMixins } from "@/pages/ClassifyManagement/classifyMixins";
import { mapActions, mapState } from "vuex";

export default {
  name: "AddClassify",
  components: { AppBox, AppHeader },
  mixins: [classifyMixins],
  data() {
    return {
      isAdd: true,
      isAddContent: "目录管理 | 新增目录",
      isEditContent: "课程分类 | 编辑分类",
      options: [
        {
          value: 0,
          label: "作为一级目录",
          disabled: false,
        },
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", ["classifyList"]),
  },
  async mounted() {
    if (this.$route.params.type === "add") {
      this.clearForm();
      this.isAdd = true;
      await this.getClassTree({
        parentId: null,
      });
      this.options = this.options.concat(
        this.formatData(this.classifyList.data)
      );
    }
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
      const classifyDetail = JSON.parse(localStorage.getItem("classifyDetail"));
      await this.getClassTree({
        parentId: classifyDetail.id,
      });
      this.options = this.options.concat(
        this.formatData(this.classifyList.data)
      );
      Object.keys(this.formData).map((key) => {
        this.formData[key] = classifyDetail[key];
      });
    }
  },
  methods: {
    ...mapActions("teachingCenter", ["getClassTree", "saveClassTree"]),
    async handleAdd() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveClassTree({
            ...this.formData,
          });
          this.$message.success("新增成功");
          this.options = [
            {
              value: 0,
              label: "作为一级目录",
              disabled: false,
            },
          ];
          await this.getClassTree({
            parentId: null,
          });
          this.options = this.options.concat(
            this.formatData(this.classifyList.data)
          );
          this.clearForm();
          this.isAdd = true;
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        }
      });
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        newVal[index] = {
          value: item.id,
          label: item.name,
          disabled: !!item.subjectNumber,
        };
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddClassify {
  .appBox {
    width: 100%;
    position: relative;
    height: calc(100vh - 155px);

    .point {
      color: #c0c4cc;
      margin-left: 20px;
      cursor: default;
    }

    .footer {
      position: absolute;
      text-align: center;
      bottom: 200px;
      right: 50px;
      left: 50px;
    }
  }
}
</style>
